import React, { useContext, useState } from 'react';
import { useMutation } from 'react-query';
import { getAxiosTokenInstance } from '../../utils/axiosInstance';
import { FirebaseContext } from '../../context/FirebaseContext';
import LoadingAnimation from '../../components/LoadingAnimation';
import { Body, Header, Main } from '../../NecttosComp/Layout/Layout';
import Button from '../../NecttosComp/Button/Button';
import Input2 from '../../NecttosComp/Input/Input2';
import Instruction from '../../Documentation/Instruction';

export const exportPdf = async ({ olddata, setLoading }) => {
	const instance = await getAxiosTokenInstance();

	const data = {
		collegeId: olddata.collegeId,
		accessionNumbers: olddata.year,
		start: olddata.start,
		end: olddata.end,
	};

	try {
		const resp = await instance.post(`/college/reportGeneration/barcodeSpinalLabel`, data, {
			responseType: 'blob',
		});

		if (resp.data.statusCode === 400) {
			setLoading(false);
			throw new Error(resp.data.message || 'API Error');
		}
		return resp.data;
	} catch (error) {
		setLoading(false);
		throw new Error(error?.response?.data?.message || error.message || 'API Error');
	}
};

export const Labels = ({ onClose }) => {
	const { collegeId } = useContext(FirebaseContext);
	const [custom, setCustom] = useState(false);
	const [stateData, setStateData] = useState({});
	const [loading, setLoading] = useState(false);
	const exportPdfMutation = useMutation(exportPdf);

	const onExportExam = async () => {
		setLoading(true);
		try {
			const link = document.createElement('a');
			link.target = '_blank';
			const olddata = {
				collegeId,
				year: stateData.year,
				start: stateData.start,
				end: stateData.end,
			};
			link.download = 'Exam Reg Support';
			const pdfData = await exportPdfMutation.mutateAsync({ olddata, setLoading });
			link.href = URL.createObjectURL(new Blob([pdfData], { type: 'application/pdf' }));
			link.click();
			setLoading(false);
			onClose();
		} catch (e) {
			setLoading(false);
		}
	};

	return (
		<Main width='80%' height='auto' title='Spinal, Barcode & Secret Labels'>
			<Header className='justify-between'>
				<h2 className='text-lg font-semibold text-gray-800 dark:text-gray-200'>Label Generator</h2>
				<div className='flex justify-end'>
					<Instruction keyId={'labels'} />
					<Button type='close' onClick={onClose}>
						Close
					</Button>
				</div>
			</Header>

			<Body>
				{loading ? (
					<LoadingAnimation dark />
				) : (
					<div>
						<div className='flex items-center justify-between '>
							<h3 className='text-xl font-bold text-gray-900 dark:text-white'>Spinal, Barcode & Secret Labels</h3>
							<label className='inline-flex items-center text-sm gap-2'>
								<input type='checkbox' className='h-5 w-5' checked={custom} onChange={() => setCustom(!custom)} />
								<span className='text-gray-800 dark:text-gray-200'>Custom Year</span>
							</label>
						</div>

						{custom ? (
							<Input2 width='90%' fieldName='Custom Year' returnKey='year' state={stateData} setState={setStateData} type='text' className='w-full' />
						) : (
							<div className='grid grid-cols-1 md:grid-cols-2 gap-2'>
								{/* starting rollno,ending roll no  */}
								<Input2 width='99%' fieldName='From' returnKey='start' state={stateData} setState={setStateData} type='text' />
								<Input2 width='99%' fieldName='To' returnKey='end' state={stateData} setState={setStateData} type='text' />
							</div>
						)}

						<div className='flex justify-end'>
							<Button type='save' onClick={onExportExam}>
								Download Labels PDF
							</Button>
						</div>
					</div>
				)}
			</Body>
		</Main>
	);
};
